module.exports = __webpack_public_path__ + "img/danger.429ebfe2.svg";